import { useNavigate } from "react-router-dom";
import { ChevronLeft, Check } from "lucide-react";
import { PackButtons, Guarantee } from "../components/UpsellSheet";

export default function Paywall() {
  const navigate = useNavigate();

  return (
    <div className="mm-frame mm-glow relative flex flex-col bg-white" data-testid="paywall-page">
      <div className="relative z-10 px-5 pt-6 flex items-center">
        <button data-testid="paywall-back" onClick={() => navigate(-1)} className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center"><ChevronLeft size={22} className="text-navy" /></button>
      </div>

      <div className="relative z-10 flex-1 overflow-y-auto mm-scroll px-6 pb-8">
        <div className="text-center mt-4">
          <div className="inline-flex items-center gap-2 bg-royal/10 text-royal rounded-full px-3 py-1.5 text-xs font-bold">
            Unlock your season
          </div>
          <h1 className="font-serif text-4xl font-bold text-navy mt-4 leading-tight">Keep your mind<br />in the game</h1>
          <p className="text-slate-500 mt-3">Just <span className="font-bold text-navy">$0.99 a session</span> — each unlock is a personalized visualization plus bonus content, yours to replay free forever.</p>
        </div>

        <div className="mt-8"><PackButtons /></div>

        <div className="mt-6"><Guarantee /></div>

        <ul className="mt-6 space-y-2.5">
          {["Personalized to your sport, position & goals", "Choose your guide's voice", "Replays are always free", "New content adapts as you grow"].map((t) => (
            <li key={t} className="flex items-center gap-2.5 text-navy text-sm"><Check size={16} className="text-royal shrink-0" /> {t}</li>
          ))}
        </ul>
        <p className="text-center text-[11px] text-slate-400 mt-6">Secure checkout by Stripe · Test mode</p>
      </div>
    </div>
  );
}
